function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 3.825,
    height: 19.124,
    x: 9.913,
    y: 2.288,
    ry: 1.527,
    style: {
      fill: "#e5ffd5",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.825,
    height: 19.124,
    x: -13.762,
    y: 2.263,
    ry: 1.527,
    style: {
      fill: "#e5ffd5",
      fillOpacity: 1
    },
    transform: "rotate(-90)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.3d3eae10a1b07dc31721d882bb5609b4.svg";
export { ForwardRef as ReactComponent };